import React, { useState } from 'react';
import { Row, Col, Button, Radio, Input, Table, Tabs, Skeleton, DatePicker, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { UserOutlined } from "@ant-design/icons";
import moment from 'moment';
import LayoutDetail from '../Layout/';
import useWindowDimensions from '../../hooks/windowDimensionsHook';
import { useLocation } from "react-router-dom";
import apick from '../../api/apicheckout';
const { TextArea } = Input;
const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

function EPrescription() {
    const { height, width } = useWindowDimensions();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    return (
        <LayoutDetail breadCrumbTitle='Cadastro de Pagamento'>
            <Row style={{ backgroundColor: '#ccc', padding: 10 }}>
                <Col>
                    <h2>EvPrescription</h2>
                </Col>
            </Row>
            <Row>
                <h2>Vamos começar, selecione o cliente:</h2>
            </Row>
            <Row>
            <Select
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                >
                <Option value="1">Sem acesso a dados</Option>
            </Select>
            </Row>
        </LayoutDetail>
    );
}

export default EPrescription;
